import React, { FC, ReactNode } from 'react';
import { Box } from '@mui/material';
import classNames from 'classnames';
import { PageTitle } from '../PageTitle';

interface Props {
  children: ReactNode;
  title?: string;
  containerClassName?: string;
}
export const MainContainer: FC<Props> = ({
  children,
  title,
  containerClassName,
  ...rest
}) => (
  <Box
    className={classNames(
      'w-full mx-auto container p-0 flex flex-col gap-8 sm:gap-12 px-3 sm:px-6',
      containerClassName || '!py-6 sm:!py-12'
    )}
    {...rest}
  >
    {title && (
      <Box className="flex gap-4 flex-col">
        <PageTitle title={title} />
      </Box>
    )}

    <Box>{children}</Box>
  </Box>
);
